import React from 'react';
import { Form, FormGrid, LoadingIndicator, OccupyFreeSpace, SimpleDialog } from '../../toolympus/components/primitives';
import { useGanttsList } from './useGanttsList';
import { FormControlsForFields, TableForFields } from '../../toolympus/components/schemed';
import { StrippedIconButton } from '../../toolympus/components/primitives/StrippedButtons';
import { Add } from '@mui/icons-material';

interface Props {
  
}

export const GanttListPage = (props: Props) => {
  const data = useGanttsList();

  return (<>
    <Form
      title="Планирование"
      headerItems={<>
        <OccupyFreeSpace />
        {!!data.isLoading && <LoadingIndicator sizeVariant="s" />}
        <StrippedIconButton
          onClick={() => data.newRecord.startEditing()}
          color="primary"
          >
          <Add />
        </StrippedIconButton>
      </>}>
      <TableForFields
        stickyHeader
        data={data.data}
        fields={[
          ["title"],
          ["tasks_count"],
          ["created_at", { utcToLocal: true }],
          ["created_by", { utcToLocal: true }],
        ]}
        schema={data.schema}
        fieldLink={f => {
          if(f === "title" || f === "tasks_count") {
            return r => `/g/${r._id}`;
          }
        }}
        />
    </Form>

    <SimpleDialog
      {...data.newRecord.dialog}
      dialogTitle="Создать"
      noFullscreen
      save={() => data.newRecord.save()}
      >
      {!!data.newRecord.item &&
        <FormGrid columns="1fr">
          <FormControlsForFields
            data={data.newRecord.item}
            onChange={(o,c) => data.newRecord.update(c)}
            fields={[
              ["title", { controlProps: { autoFocus: true }}],
            ]}
            schema={data.schema}
            />
        </FormGrid>}
    </SimpleDialog>
  </>);
}
